<mat-drawer-container class="admin-container" autosize>
  <mat-drawer
    #drawer
    class="admin-drawer"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async) || (adminLayoutService.isSidenavOpen$ | async)"
    [class.minimized]="!(adminLayoutService.isSidenavOpen$ | async) && !(isHandset$ | async)"
    (closed)="closeDrawer()"
  >
    <mat-nav-list [disableRipple]="true">
      <a mat-list-item (click)="toggleDrawer()">
        <div class="nav-item-content">
          <mat-icon>menu</mat-icon>
          <span>Menü</span>
        </div>
      </a>

      <mat-divider></mat-divider>

      <a mat-list-item routerLink="/admin/dashboard" routerLinkActive="active">
        <div class="nav-item-content">
          <mat-icon>dashboard</mat-icon>
          <span>Dashboard</span>
        </div>
      </a>
      <a mat-list-item routerLink="/admin/analytics" routerLinkActive="active">
        <div class="nav-item-content">
          <mat-icon>analytics</mat-icon>
          <span>Analytics</span>
        </div>
      </a>
      <a mat-list-item routerLink="/admin/reststop" routerLinkActive="active">
        <div class="nav-item-content">
          <mat-icon>edit_location_alt</mat-icon>
          <span>Raststätten</span>
        </div>
      </a>
      <a mat-list-item routerLink="/admin/users" routerLinkActive="active">
        <div class="nav-item-content">
          <mat-icon>people</mat-icon>
          <span>Nutzerverwaltung</span>
        </div>
      </a>
      <a mat-list-item routerLink="/admin/roles" routerLinkActive="active">
        <div class="nav-item-content">
          <mat-icon>security</mat-icon>
          <span>Rollenverwaltung</span>
        </div>
      </a>
      <a mat-list-item routerLink="/admin/sync" routerLinkActive="active">
        <div class="nav-item-content">
          <mat-icon>sync</mat-icon>
          <span>Sync</span>
        </div>
      </a>
      <a mat-list-item routerLink="/admin/map" routerLinkActive="active">
        <div class="nav-item-content">
          <mat-icon>map</mat-icon>
          <span>Map</span>
        </div>
      </a>
    </mat-nav-list>
  </mat-drawer>

  <mat-drawer-content class="admin-content">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
